import { render, staticRenderFns } from "./textEditor.vue?vue&type=template&id=31602860"
import script from "./textEditor.vue?vue&type=script&lang=js"
export * from "./textEditor.vue?vue&type=script&lang=js"
import style0 from "./textEditor.vue?vue&type=style&index=0&id=31602860&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports